// extracted by mini-css-extract-plugin
module.exports = {"root":"hChVDEZFSFiD","button":"_2E2WmoRQphir"};